export default "__VITE_ASSET__CEYn3qt___"